export default "__VITE_ASSET__DenyryBJ__"